// extracted by mini-css-extract-plugin
export default {"container":"il-z","blurb":"jl-z","links":"kl-z"};